import Button from '../components/common/Button';
import ContactCTA from '../components/common/ContactCTA';
import { equipmentRepairGroups, gearboxBrands, marqueeBrandLogos } from '../data/equipmentRepair';

function Equipment() {
  const firstLogoRow = marqueeBrandLogos.slice(0, 10);
  const secondLogoRow = marqueeBrandLogos.slice(10, 20);

  return (
    <>
      <section className="equipment-page-hero" aria-labelledby="equipment-page-title">
        <div className="container equipment-page-hero__inner">
          <p className="eyebrow">Equipment Repair</p>
          <h1 id="equipment-page-title">Gearbox, hydraulic, and industrial equipment repair</h1>
          <p>
            We support repair inquiries for industrial gearboxes, hydraulic cylinders, pumps, drive components, and
            related mechanical equipment across Canada.
          </p>
          <div className="equipment-page-hero__actions">
            <Button to="/contact">Request a Quote</Button>
            <Button href="tel:+14374357083" variant="secondary">
              Call (437) 435-7083
            </Button>
          </div>
        </div>
      </section>

      <section className="equipment-page-section">
        <div className="container">
          <div className="equipment-page-grid">
            {equipmentRepairGroups.map((group) => (
              <article key={group.title} className="equipment-page-card">
                <div className="equipment-page-card__body">
                  <h2>{group.title}</h2>
                  <p>{group.summary}</p>
                  <ul>
                    {group.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="equipment-page-brands" aria-labelledby="equipment-brands-title">
        <div className="container equipment-page-brands__inner">
          <div>
            <p className="eyebrow">Gearbox Brands</p>
            <h2 id="equipment-brands-title">Common gearbox names and manufacturers</h2>
            <p>
              If your gearbox brand is not listed, send the nameplate, photos, and equipment details. The list below is
              meant as a starting point for repair conversations.
            </p>
          </div>
          <div className="equipment-page-logo-marquee" aria-label="Common gearbox brand logos">
            {[firstLogoRow, secondLogoRow].map((row, rowIndex) => (
              <div
                key={rowIndex}
                className={`equipment-page-logo-marquee__row${
                  rowIndex === 1 ? ' equipment-page-logo-marquee__row--reverse' : ''
                }`}
              >
                <div className="equipment-page-logo-marquee__track">
                  {[...row, ...row].map((brand, index) => (
                    <span key={`${brand.name}-${index}`} className="equipment-page-logo-marquee__item">
                      <img src={`${process.env.PUBLIC_URL}/images/brand-logos/${brand.file}`} alt={brand.name} />
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="equipment-page-brand-list">
            {gearboxBrands.map((brand) => (
              <span key={brand}>{brand}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="equipment-page-note">
        <div className="container equipment-page-note__inner">
          <p className="eyebrow">Quote Details</p>
          <h2>Useful details for a repair review</h2>
          <p>
            Include photos, manufacturer name, model number, equipment type, symptoms, dimensions, and any downtime
            urgency. Clear details make the first repair conversation faster and more practical.
          </p>
          <Button to="/contact" variant="outline-light">
            Start a Repair Request
          </Button>
        </div>
      </section>

      <ContactCTA />
    </>
  );
}

export default Equipment;
